import type { Status } from "./types";

export type StatusBadgeVariant =
  "primary" | "info" | "success" | "warning" | "danger" | "muted" | "secondary";

interface StatusBadgeProps {
  status: Status | string;
  variant?: StatusBadgeVariant;
  pill?: boolean;
}

const variantClassNames: Record<StatusBadgeVariant, string> = {
  primary: "text-primary",
  success: "text-success",
  warning: "text-warning",
  info: "text-info",
  danger: "text-danger",
  muted: "text-muted",
  secondary: "text-secondary",
};

const pillVariantClassNames: Record<StatusBadgeVariant, string> = {
  primary: "bg-light text-primary border",
  success: "bg-light text-success border border-success",
  warning: "bg-light text-warning border border-warning",
  info: "bg-light text-info border border-info",
  danger: "bg-light text-danger border border-danger",
  muted: "bg-light text-muted border",
  secondary: "bg-light text-secondary border",
};

export const getStatusBadgeVariant = (
  status: Status | string,
): StatusBadgeVariant => {
  switch (status) {
    case "Aktiv":
      return "primary";
    case "Godkendt":
      return "success";
    case "Afventer":
      return "warning";
    case "Afsluttet":
      return "secondary";
    default:
      return "muted";
  }
};

export const StatusBadge = ({ status, variant, pill }: StatusBadgeProps) => {
  const resolvedVariant = variant ?? getStatusBadgeVariant(status);
  const className = pill
    ? `badge rounded-2 px-3 py-2 fw-semibold ${pillVariantClassNames[resolvedVariant]}`
    : `fw-semibold ${variantClassNames[resolvedVariant]}`;

  return <span className={className}>{status}</span>;
};
